import { isRolloutFlagEnabled } from '@pequity/shared/utils/rollout-flags';
import { type NavigationGuard } from 'vue-router';
import { JOB_ARCHITECTURE_BUILDER_FLAG } from '@/job-architecture-builder/constants';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfBuilderUnavailable: NavigationGuard = (to, from, next) => {
  const { isUserAdmin } = useAuthStore();

  if (!isUserAdmin || !isRolloutFlagEnabled(JOB_ARCHITECTURE_BUILDER_FLAG)) {
    return next({ name: 'home' });
  }
  return next();
};
